import ChangeOTPMethod from "./ChangeOTPMethod";
export default ChangeOTPMethod;